// Import necessary styles and libraries
import { createApp } from 'vue';
import Purchases from "./Purchases.vue";

// Check if the specific element exists in the DOM
if (document.querySelector('#purchases')) {
  // Create a new Vue instance and mount it to the element
  const app = createApp(Purchases);
  app.mount('#purchases');
  window.purchaseVueAppMounted = true;
}
